export default __webpack_public_path__ + "static/media/camcorder.4c4e1d70.JPG";